import { getActivityLogTranslation } from '@app/utils/log';

export const ActivityLog = {
  USER_SIGNUP: 'USER_SIGNUP',
  USER_INVITE: 'USER_INVITE',
  INTEGRATION_CONNECTED: 'INTEGRATION_CONNECTED',
  INTEGRATION_FAILED: 'INTEGRATION_FAILED',
  AUTOMATION_TRIGGERED: 'AUTOMATION_TRIGGERED',
  MESSAGE_SENT: 'MESSAGE_SENT',
  MESSAGE_FAILED: 'MESSAGE_FAILED',
  REVIEWS_SYNCED: 'REVIEWS_SYNCED',
  SYSTEM: 'SYSTEM',
} as const;

export const ACTIVITY_LOG_OPTIONS = Object.values(ActivityLog).map((value) => ({
  value,
  label: getActivityLogTranslation(value),
}));
